<template>
    <div class="about">
        <h1>Not found page 404</h1>
    </div>
</template>
